import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SubscriptionComponent } from 'app/core/utils/subscription.component';
import {
  DxTextBoxModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxScrollViewModule,
} from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxTemplateModule,
    DxTextAreaModule,
    DxScrollViewModule,
    TranslateModule,
  ],
})
export class ErrorDialogComponent extends SubscriptionComponent implements AfterViewInit {
  @ViewChild('okFocus') okButton!: ElementRef;

  @Input()
  code?: string;

  @Input()
  isWarning = false;

  @Input()
  message = '';

  @Input()
  showCopy = false;

  @Output() closeClick = new EventEmitter<void>();

  constructor(public translateService: TranslateService) {
    super();
  }

  ngAfterViewInit(): void {
    this.okButton.nativeElement.focus();
  }

  onCopyClick(): void {
    navigator.clipboard.writeText(this.message);
  }

  onCloseClick() {
    this.closeClick.emit();
  }
}
